export const passMessages = {
  cs: {
    "passes.title": "Moje permanentky",
    "passes.description": "Zůstatky, karta na recepci a další návštěva na jednom místě.",
    "passes.mine": "Vaše permanentky",
    "passes.archive": "Dřívější permanentky ({count})",
    "passes.freeNote": "Tato permanentka je zdarma. Po potvrzení ji najdete ve svém přehledu.",
    "passes.empty": "Aktuálně nemáte permanentku k využití. Vyberte si z nabídky níže.",
    "passes.available": "K dispozici",
    "passes.visits": "{count} vstupů",
    "passes.visits.one": "{count} vstup",
    "passes.visits.few": "{count} vstupy",
    "passes.minutes": "{count} minut",
    "passes.minutes.one": "{count} minuta",
    "passes.minutes.few": "{count} minuty",
    "passes.unlimited": "Neomezené vstupy",
    "passes.reserved": "V rezervacích: {count}",
    "passes.validUntil": "Platí do {date}",
    "passes.validFrom": "Začíná {date}",
    "passes.firstUse": "Aktivuje se první návštěvou, nejpozději {date}",
    "passes.family": "Oprávnění návštěvníci: {names}",
    "passes.shared": "Sdílená permanentka",
    "passes.sharedPrivacy": "Zůstatek sdílíte s dalšími oprávněnými návštěvníky. Níže vidíte pouze své návštěvy.",
    "passes.card": "Karta a historie",
    "passes.hideCard": "Zavřít kartu",
    "passes.cardHint": "Ukažte QR kód na recepci. Obsluha ověří platnost a potvrdí návštěvu.",
    "passes.qrAlt": "QR kód permanentky {name}",
    "passes.copy": "Kopírovat kód",
    "passes.copied": "Kód zkopírován",
    "passes.copyError": "Kód se nepodařilo zkopírovat. Ukažte jej recepci.",
    "passes.loading": "Načítání…",
    "passes.detailError": "Kartu se nepodařilo načíst. Zkuste to znovu.",
    "passes.refresh": "Obnovit přehled",
    "passes.retry": "Zkusit znovu",
    "passes.history": "Historie čerpání",
    "passes.noHistory": "Zatím bez pohybů.",
    "passes.visitsTitle": "Návštěvy",
    "passes.openVisit": "Právě probíhá",
    "passes.reversedVisit": "Návštěva stornována",
    "passes.overtime": "Doplatek za čas: {amount}",
    "passes.catalog": "Vybrat další permanentku",
    "passes.noOffers": "Aktuální nabídku vám rádi sdělí na recepci.",
    "passes.fixedValidity": "Platí od {from} do {until} včetně",
    "passes.fixedPeriodExpired": "Platnost této nabídky už skončila. Obnovte přehled a vyberte si aktuální permanentku.",
    "passes.fixedPeriodInvalid": "Období této permanentky není správně nastavené. Obraťte se na recepci.",
    "passes.fixedStartNotAllowed": "Tato permanentka má pevné období a její začátek nelze posunout.",
    "passes.fixedPeriodCannotExtend": "Tato permanentka má pevný konec platnosti, který nelze prodloužit.",
    "passes.fixedRenewalNote": "Získáte nový samostatný zůstatek pro stejné období. Konec platnosti se neposune.",
    "passes.validity": "Platnost {count} dní",
    "passes.validity.one": "Platnost {count} den",
    "passes.validity.few": "Platnost {count} dny",
    "passes.activatesOnFirstUse": "Platnost běží od první návštěvy",
    "passes.activatesOnPayment": "Platnost běží od potvrzení úhrady",
    "passes.visitDuration": "Délka jedné návštěvy: {count} minut",
    "passes.visitDuration.one": "Délka jedné návštěvy: {count} minuta",
    "passes.visitDuration.few": "Délka jedné návštěvy: {count} minuty",
    "passes.offerOvertime": "Po překročení času: {amount} za každých {count} minut",
    "passes.offerOvertime.one": "Po překročení času: {amount} za každou {count} minutu",
    "passes.offerOvertime.few": "Po překročení času: {amount} za každé {count} minuty",
    "passes.shareable": "Lze sdílet s návštěvníky přidanými na recepci",
    "passes.order": "Objednat",
    "passes.renew": "Koupit další",
    "passes.confirmTitle": "Objednat {name}?",
    "passes.paymentNote": "Zaplatíte na recepci. Permanentka bude použitelná až po potvrzení úhrady obsluhou.",
    "passes.renewalNote": "Časové členství naváže na konec stávající platnosti. Nový balíček vstupů nebo minut bude připraven podle svých podmínek po úhradě.",
    "passes.confirmOrder": "Potvrdit objednávku",
    "passes.back": "Zpět",
    "passes.pendingOrders": "K úhradě na recepci",
    "passes.reference": "Číslo objednávky",
    "passes.cancelOrder": "Zrušit objednávku",
    "passes.ready": "Permanentka je připravená. Najdete ji ve svém přehledu.",
    "passes.orderPlaced": "Objednávka je připravená k úhradě na recepci.",
    "passes.orderCancelled": "Objednávka byla zrušena.",
    "passes.orderError": "Objednávku se nepodařilo dokončit. Obnovte přehled a zkuste to znovu.",
    "passes.unknownResult": "Spojení bylo přerušeno. Zkuste potvrzení znovu; stejnou objednávku nevytvoříme dvakrát.",
    "passes.saving": "Ukládání…",
    "passes.status.active": "Aktivní",
    "passes.status.pending": "Čeká na aktivaci",
    "passes.status.scheduled": "Platnost začne později",
    "passes.status.frozen": "Pozastavená",
    "passes.status.expired": "Platnost skončila",
    "passes.status.exhausted": "Vyčerpaná",
    "passes.status.cancelled": "Zrušená",
    "passes.status.unpaid": "Čeká na úhradu",
    "passes.movements.issued": "Vydání permanentky",
    "passes.movements.paid": "Úhrada potvrzena",
    "passes.movements.reserved": "Vstup rezervován",
    "passes.movements.released": "Rezervace vstupu uvolněna",
    "passes.movements.consumed": "Čerpání",
    "passes.movements.returned": "Vrácení vstupu",
    "passes.movements.adjusted": "Úprava zůstatku",
    "passes.movements.frozen": "Pozastavení",
    "passes.movements.resumed": "Obnovení",
    "passes.movements.extended": "Prodloužení platnosti",
    "passes.movements.cancelled": "Zrušení",
    "passes.movements.other": "Změna permanentky",
    "passes.booking.use": "Uplatnit permanentku",
    "passes.booking.noPass": "Bez permanentky",
    "passes.booking.hint": "Vstup se zablokuje pro tento termín. Při včasném zrušení rezervace se vrátí.",
    "passes.booking.covered": "Hrazeno permanentkou",
    "passes.booking.cancel": "Zrušit rezervaci",
    "passes.booking.cancelConfirm": "Opravdu zrušit rezervaci? Blokovaný vstup se vrátí.",
    "passes.booking.cancelHint": "Rezervaci můžete zrušit před začátkem.",
    "passes.booking.cancelled": "Rezervace byla zrušena.",
    "passes.booking.cancelError": "Rezervaci se nepodařilo zrušit. Obnovte přehled nebo kontaktujte recepci.",
  },
  en: {
    "passes.title": "My passes",
    "passes.description": "Your balance, reception card and next visit in one place.",
    "passes.mine": "Your passes",
    "passes.archive": "Previous passes ({count})",
    "passes.freeNote": "This pass is free. It will appear in your overview after confirmation.",
    "passes.empty": "You do not have a pass available now. Choose an offer below.",
    "passes.available": "Available",
    "passes.visits": "{count} visits",
    "passes.visits.one": "{count} visit",
    "passes.visits.few": "{count} visits",
    "passes.minutes": "{count} minutes",
    "passes.minutes.one": "{count} minute",
    "passes.minutes.few": "{count} minutes",
    "passes.unlimited": "Unlimited visits",
    "passes.reserved": "Reserved: {count}",
    "passes.validUntil": "Valid until {date}",
    "passes.validFrom": "Starts {date}",
    "passes.firstUse": "Activates on your first visit, no later than {date}",
    "passes.family": "Authorized visitors: {names}",
    "passes.shared": "Shared pass",
    "passes.sharedPrivacy": "The balance is shared with other authorized visitors. Only your own visits are shown below.",
    "passes.card": "Card and history",
    "passes.hideCard": "Close card",
    "passes.cardHint": "Show the QR code at reception. Staff will check validity and confirm your visit.",
    "passes.qrAlt": "QR code for {name}",
    "passes.copy": "Copy code",
    "passes.copied": "Code copied",
    "passes.copyError": "Could not copy the code. Show it at reception.",
    "passes.loading": "Loading…",
    "passes.detailError": "Could not load your card. Please try again.",
    "passes.refresh": "Refresh overview",
    "passes.retry": "Try again",
    "passes.history": "Usage history",
    "passes.noHistory": "No activity yet.",
    "passes.visitsTitle": "Visits",
    "passes.openVisit": "In progress",
    "passes.reversedVisit": "Visit reversed",
    "passes.overtime": "Extra time charge: {amount}",
    "passes.catalog": "Choose another pass",
    "passes.noOffers": "Please ask reception about the current offer.",
    "passes.fixedValidity": "Valid from {from} through {until}",
    "passes.fixedPeriodExpired": "This offer has expired. Refresh the overview and choose a current pass.",
    "passes.fixedPeriodInvalid": "This pass period is not configured correctly. Please contact reception.",
    "passes.fixedStartNotAllowed": "This pass has a fixed period and its start cannot be moved.",
    "passes.fixedPeriodCannotExtend": "This pass has a fixed expiry date that cannot be extended.",
    "passes.fixedRenewalNote": "You receive a separate balance for the same period. The expiry date stays the same.",
    "passes.validity": "Valid for {count} days",
    "passes.validity.one": "Valid for {count} day",
    "passes.validity.few": "Valid for {count} days",
    "passes.activatesOnFirstUse": "Validity starts on your first visit",
    "passes.activatesOnPayment": "Validity starts when payment is confirmed",
    "passes.visitDuration": "Up to {count} minutes per visit",
    "passes.visitDuration.one": "Up to {count} minute per visit",
    "passes.visitDuration.few": "Up to {count} minutes per visit",
    "passes.offerOvertime": "Extra time: {amount} per {count} minutes",
    "passes.offerOvertime.one": "Extra time: {amount} per {count} minute",
    "passes.offerOvertime.few": "Extra time: {amount} per {count} minutes",
    "passes.shareable": "Can be shared with visitors added at reception",
    "passes.order": "Order",
    "passes.renew": "Buy another",
    "passes.confirmTitle": "Order {name}?",
    "passes.paymentNote": "Pay at reception. Your pass becomes usable after staff confirm payment.",
    "passes.renewalNote": "A time membership follows your current expiry. A new visit or minute package becomes available under its own terms after payment.",
    "passes.confirmOrder": "Confirm order",
    "passes.back": "Back",
    "passes.pendingOrders": "Pay at reception",
    "passes.reference": "Order reference",
    "passes.cancelOrder": "Cancel order",
    "passes.ready": "Your pass is ready. You can find it in your overview.",
    "passes.orderPlaced": "Your order is ready for payment at reception.",
    "passes.orderCancelled": "Your order was cancelled.",
    "passes.orderError": "Could not complete the order. Refresh the overview and try again.",
    "passes.unknownResult": "The connection was interrupted. Confirm again; the same order will not be created twice.",
    "passes.saving": "Saving…",
    "passes.status.active": "Active",
    "passes.status.pending": "Awaiting activation",
    "passes.status.scheduled": "Starts later",
    "passes.status.frozen": "Paused",
    "passes.status.expired": "Expired",
    "passes.status.exhausted": "Used up",
    "passes.status.cancelled": "Cancelled",
    "passes.status.unpaid": "Awaiting payment",
    "passes.movements.issued": "Pass issued",
    "passes.movements.paid": "Payment confirmed",
    "passes.movements.reserved": "Visit reserved",
    "passes.movements.released": "Reservation released",
    "passes.movements.consumed": "Usage",
    "passes.movements.returned": "Visit returned",
    "passes.movements.adjusted": "Balance adjusted",
    "passes.movements.frozen": "Paused",
    "passes.movements.resumed": "Resumed",
    "passes.movements.extended": "Validity extended",
    "passes.movements.cancelled": "Cancelled",
    "passes.movements.other": "Pass updated",
    "passes.booking.use": "Use a pass",
    "passes.booking.noPass": "Without a pass",
    "passes.booking.hint": "A visit is reserved for this time. It is returned when you cancel before the start.",
    "passes.booking.covered": "Covered by your pass",
    "passes.booking.cancel": "Cancel booking",
    "passes.booking.cancelConfirm": "Cancel this booking? Your reserved visit will be returned.",
    "passes.booking.cancelHint": "You can cancel before the booking starts.",
    "passes.booking.cancelled": "Your booking was cancelled.",
    "passes.booking.cancelError": "Could not cancel this booking. Refresh the overview or contact reception.",
  },
} as const;
